// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".setting[data-v-2a574655] .el-input__inner{height:30px!important}", ""]);
// Exports
module.exports = exports;
